import React from "react";

// Social Media Icons
function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      focusable="false"
      viewBox="0 0 1000 1000"
      aria-labelledby="titleAccess-instagram"
      role="img"
      style={{ fill: "#333333" }}
    >
      <path
        d="M295.42,6c-53.2,2.51-89.53,11-121.29,23.48-32.87,12.81-60.73,30-88.45,57.82S40.89,143,28.17,175.92c-12.31,31.83-20.65,68.19-23,121.42S2.3,367.68,2.56,503.46,3.42,656.26,6,709.6c2.54,53.19,11,89.51,23.48,121.28,12.83,32.87,30,60.72,57.83,88.45S143,964.09,176,976.83c31.8,12.29,68.17,20.67,121.39,23s70.35,2.87,206.09,2.61,152.83-.86,206.16-3.39S799.1,988,830.88,975.58c32.87-12.86,60.74-30,88.45-57.84S964.1,862,976.81,829.06c12.32-31.8,20.69-68.17,23-121.35,2.33-53.37,2.88-70.41,2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45S862,40.87,829.07,28.19c-31.82-12.31-68.17-20.7-121.39-23S637.33,2.3,501.54,2.56,348.75,3.4,295.42,6m5.84,903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29,2.53-202c2.08-48.71,10.23-75.21,17-92.84,9-23.39,19.84-40,37.29-57.57s34.1-28.39,57.43-37.51c17.62-6.88,44.06-15.06,92.79-17.38,52.73-2.5,68.53-3,202-3.29s149.31.21,202.06,2.53c48.71,2.12,75.22,10.19,92.83,17,23.37,9,40,19.81,57.57,37.29s28.4,34.07,37.52,57.45c6.89,17.57,15.07,44,17.37,92.76,2.51,52.73,3.08,68.54,3.32,202s-.23,149.31-2.54,202c-2.13,48.75-10.21,75.23-17,92.89-9,23.35-19.85,40-37.31,57.56s-34.09,28.38-57.43,37.5c-17.6,6.87-44.07,15.07-92.76,17.39-52.73,2.48-68.53,3-202.05,3.29s-149.27-.25-202-2.53m407.6-674.61a60,60,0,1,0,59.88-60.1,60,60,0,0,0-59.88,60.1M245.77,503c.28,141.8,115.44,256.49,257.21,256.22S759.52,643.8,759.25,502,643.79,245.48,502,245.76,245.5,361.22,245.77,503m90.06-.18a166.67,166.67,0,1,1,167,166.34,166.65,166.65,0,0,1-167-166.34"
        transform="translate(-2.5 -2.5)"
        fill="#333333"
      />
      <title id="titleAccess-instagram">Instagram</title>
    </svg>
  );
}

function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      focusable="false"
      viewBox="100 100 500 500"
      aria-labelledby="titleAccess-facebook"
      role="img"
      style={{ fill: "#333333" }}
    >
      <path
        d="M600,350c0-138.1-111.9-250-250-250S100,211.9,100,350c0,117.2,80.7,215.6,189.6,242.6V426.4h-51.6V350h51.6v-32.9c0-85.1,38.5-124.5,122-124.5c15.8,0,43.2,3.1,54.3,6.2V268c-5.9-0.6-16.1-0.9-28.9-0.9c-41,0-56.8,15.5-56.8,55.9v27h81.7l-14,76.4h-67.6v171.8C504.1,583.2,600,477.8,600,350z"
        fill="#333333"
      />
      <title id="titleAccess-facebook">Facebook</title>
    </svg>
  );
}

function XIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      focusable="false"
      viewBox="0 0 1200 1227"
      aria-labelledby="titleAccess-x"
      role="img"
      style={{ width: "15px", height: "15px" }}
    >
      <path
        d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
        fill="#333333"
      />
      <title id="titleAccess-x">X icon</title>
    </svg>
  );
}

export default function Footer() {
  const companyLinks = [
    { label: "About us", href: "/about" },
    { label: "Newsroom", href: "/news", external: true },
    { label: "Careers", href: "/careers" },
    { label: "Affiliates", href: "/affiliates" },
    { label: "Blog", href: "https://www.faire.com/blog/", external: true },
  ];

  const exploreLinks = [
    { label: "Help center", href: "/support/retailers", external: true },
    { label: "Open with Faire", href: "/open-with-faire", external: true },
    { label: "Faire Markets", href: "/markets", external: true },
    { label: "Sell on Faire", href: "/brands" },
    { label: "Small Business Grant", href: "/small-business-grant" },
    { label: "POS integration", href: "/point-of-sale/about" },
  ];

  const legalLinks = [
    { label: "Terms of Service", href: "/tos", external: true },
    { label: "Privacy Policy", href: "/privacy", external: true },
    { label: "Cookie Policy", href: "/privacy/cookies", external: true },
    { label: "IP Policy", href: "/copyright", external: true },
    { label: "Accessibility Policy", href: "/aoda", external: true },
    { label: "Sitemap", href: "/site-map", external: true },
  ];

  return (
    <footer className="w-full">
      <hr
        style={{
          borderBlockEnd: "0px",
          borderInline: "0px",
          inlineSize: "100vw",
          margin: "0px calc(-50vw + 50%)",
          blockSize: "1px",
          borderBlockStart: "1px solid rgb(223, 224, 225)",
        }}
      />
      <div
        className="retailer-12col-grid mx-auto px-4 md:px-12"
        style={{
          maxWidth: "1920px",
          paddingTop: "60px",
          paddingBottom: "16px",
        }}
      >
        {/* Main Footer Content */}
        {/* App Download Section - spans columns 1-4 */}
        <div
          className="flex w-full flex-col pb-8 md:pb-0"
          style={{ gridColumn: "1 / 5" }}
        >
          {/* --font-family-serif never resolves in this playground build (see FairePayClarityV2Page for the same workaround) — pin the working underlying variable directly. */}
          <p
            className="type-fs-display-s text-fs-text-primary"
            style={{ fontFamily: "var(--slate-typography-family-serif, 'Nantes', serif)" }}
          >
            Discover products on the go with the Faire app
          </p>
          <div style={{ height: "24px" }} />
          <div className="flex flex-row items-center">
            <button
              className="cursor-pointer border-0 bg-transparent p-0"
              aria-label="Download on App Store"
            >
              <img
                width="120"
                alt="Apple App Store Badge"
                src="https://cdn.faire.com/static/download-badges/app-store-en.svg"
                style={{ display: "block" }}
              />
            </button>
            <div style={{ width: "16px", height: "0px" }} />
            <button
              className="cursor-pointer border-0 bg-transparent p-0"
              aria-label="Get it on Google Play"
            >
              <img
                width="156"
                alt="Google Play Store Badge"
                src="https://cdn.faire.com/static/download-badges/google-play-en.png"
              />
            </button>
          </div>
        </div>

        {/* Divider for mobile */}
        <hr
          className="md:hidden"
          style={{
            borderBlockEnd: "0px",
            borderInline: "0px",
            inlineSize: "auto",
            margin: "0px -16px",
            blockSize: "1px",
            borderBlockStart: "1px solid rgb(223, 224, 225)",
            gridColumn: "1 / -1",
          }}
        />

        {/* Company Links - spans columns 7-8 */}
        <div
          className="flex w-full flex-col py-8 md:py-0"
          style={{ gridColumn: "7 / 9" }}
        >
          <p className="type-fs-paragraph-medium text-fs-text-primary mb-3">
            Company
          </p>
          <ul className="m-0 flex list-none flex-col gap-3 p-0">
            {companyLinks.map((link) => (
              <li key={link.href} className="flex items-center">
                <a
                  href={link.href}
                  target={link.external ? "_blank" : undefined}
                  rel={link.external ? "noopener noreferrer" : undefined}
                  className="text-fs-text-primary text-sm no-underline transition-colors duration-500 ease-in-out hover:underline"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Explore Links - spans columns 9-10 */}
        <div
          className="flex w-full flex-col py-8 md:py-0"
          style={{ gridColumn: "9 / 11" }}
        >
          <p className="type-fs-paragraph-medium text-fs-text-primary mb-3">
            Explore
          </p>
          <ul className="m-0 flex list-none flex-col gap-3 p-0">
            {exploreLinks.map((link) => (
              <li key={link.href} className="flex items-center">
                <a
                  href={link.href}
                  target={link.external ? "_blank" : undefined}
                  rel={link.external ? "noopener noreferrer" : undefined}
                  className="text-fs-text-primary text-sm no-underline transition-colors duration-500 ease-in-out hover:underline"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Social Media Icons */}
        <div
          className="flex w-fit flex-row items-center gap-8 pt-8 md:items-start lg:items-start lg:pt-0"
          style={{ gridColumn: "11 / 13" }}
        >
          <a
            href="https://www.instagram.com/faire_wholesale/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-fs-text-primary no-underline"
            aria-label="Instagram"
          >
            <InstagramIcon className="h-6 w-6" />
          </a>
          <a
            href="https://www.facebook.com/fairewholesale/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-fs-text-primary no-underline"
            aria-label="Facebook"
          >
            <FacebookIcon className="h-6 w-6" />
          </a>
          <a
            href="https://x.com/faire_wholesale"
            target="_blank"
            rel="noopener noreferrer"
            className="text-fs-text-primary no-underline"
            aria-label="X (Twitter)"
          >
            <XIcon className="mt-1 h-4 w-4" />
          </a>
        </div>

        {/* Spacer */}
        <div
          style={{ height: "32px", gridColumn: "1 / -1" }}
          className="hidden md:block"
        />

        {/* Bottom Section - Copyright and Legal Links */}
        <div
          className="flex flex-col md:flex-row md:justify-start"
          style={{ gridColumn: "1 / -1" }}
        >
          <div className="flex w-full flex-col flex-wrap md:flex-row md:items-start">
            <p className="text-fs-text-primary text-sm font-medium">
              ©2025 Faire Wholesale, Inc.
            </p>
            <div
              style={{ width: "8px", height: "8px" }}
              className="hidden md:block"
            />
            <div className="flex flex-col gap-3 md:flex-row md:gap-0">
              {legalLinks.map((link, index) => (
                <div key={link.href} className="flex flex-row items-center">
                  <a
                    href={link.href}
                    target={link.external ? "_blank" : undefined}
                    rel={link.external ? "noopener noreferrer" : undefined}
                    className="text-fs-text-primary text-sm no-underline transition-colors duration-500 ease-in-out hover:underline"
                  >
                    {link.label}
                  </a>
                  {index < legalLinks.length - 1 && (
                    <div className="hidden flex-row items-center md:flex">
                      <div style={{ width: "4px" }} />
                      <p className="text-sm text-[#757575]"> • </p>
                      <div style={{ width: "4px" }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Spacer below copyright */}
        <div style={{ height: "16px", gridColumn: "1 / -1" }} />

        {/* Bottom Spacer */}
        <div
          style={{ height: "56px", gridColumn: "1 / -1" }}
          className="md:hidden"
        />
      </div>
    </footer>
  );
}
